import styled, { css } from 'styled-components';

import { LegacyButton as BaseButton } from '@/components/LegacyButton';

import { ReactComponent as ChevronSvg } from '@/assets/icons/chevron.svg';

export const Chevron = styled(ChevronSvg)`
  fill: ${({ theme }) => theme.colors.primaryDark};
`;

export const Button = styled(BaseButton)<{ lower?: boolean }>`
  text-decoration: underline;
  text-underline-offset: ${({ theme }) => theme.spacing(0.6)};
  text-decoration-color: ${({ theme }) => theme.colors.primary};
  margin-right: ${({ theme }) => theme.spacing(0.8)};
  ${({ lower }) =>
    lower &&
    css`
      text-transform: initial;
      font-weight: 500;
    `}
`;
